(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-search"] && !Shopify.designMode) return;
  try {
    const exactSearchForm = document.getElementById('predictive-search-form');

  exactSearchForm?.addEventListener('submit', () => {
    const searchInput = exactSearchForm.elements.namedItem('q');
    const searchTerm = searchInput.value.trim().replaceAll('"', '');

    if (searchTerm) {
      searchInput.value = `"${searchTerm}"`;
    }
  });
  } catch(e) { console.error(e); }
})();

})();
